<template>
  <div
    id="loading"
    ref="loading"
    :style="{'clip': `rect(${setRectIn}px ${boxWidth}px ${setRectOut}px 0px)`}"
  >
    <img class="businesstoday" src="../assets/images/businesstoday.svg" alt="今周刊" />
    <div :class="showSlogan ? 'loadingbox shadowIn' : 'loadingbox'" ref="svgWrapper">
      <div :class="hideSlogan ? 'fade-out-top' : null">
        <img
          :class="showSlogan ? 'fadein setanimate' : 'fadein'"
          src="../assets/images/slogan.png"
          alt="2021全球經濟關鍵報告"
        />
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 -140 600 420"
          :style="{width: setSvgSize.width + 'px', height: setSvgSize.height + 'px'}"
        >
          <g :class="showSlogan ? 'fadein setanimate' : 'fadein'">
            <g>
              <path d="M223.1,46.8c-0.7,0-1.5-0.1-2.2-0.2c-0.4,0-0.7-0.1-1.1-0.1l-0.2,0l2,3.2l1-0.7h30.9c0.3,0,0.7-0.3,0.7-0.6
                c0-0.5-0.8-1.5-2.6-3.3l-0.2-0.2c-0.4-0.5-0.8-0.8-1-0.8c-0.4,0-1.2,0.8-2.8,2.5c-0.1,0.1-0.1,0.1-0.2,0.2H239V37h8.5
                c0.4,0,0.9-0.1,0.9-0.5c0-0.4-0.8-1.3-2.6-3c-0.1-0.1-0.2-0.2-0.2-0.2c-0.3-0.3-0.6-0.6-0.9-0.6c-0.4,0-2.2,1.6-2.6,2.1H239V27
                c0,0,0,0,0.1,0c0.4-0.2,0.9-0.6,0.9-1.1c0-0.3-0.2-0.5-0.5-0.7h6.3c0.3,0,0.6-0.2,0.6-0.5c0-0.4-0.7-1.2-2.4-2.8
                c-0.1-0.1-0.1-0.1-0.1-0.1c-0.3-0.3-0.7-0.7-1.1-0.7c-0.7,0-2.6,1.8-2.9,2h-10c-0.7,0-1.5-0.1-2.3-0.2c-0.3,0-0.7-0.1-1-0.1l-0.2,0
                l1.9,3.2l1-0.8h4.6v9.7h-5.7c-0.8,0-1.6-0.1-2.4-0.2c-0.3,0-0.7-0.1-1-0.1l-0.2,0l1.9,3.2l1-0.7h6.4v9.8H223.1z"/>
              <path d="M216.4,29.4C216.4,29.4,216.4,29.4,216.4,29.4c0.1,0,0.2,0,0.2,0c7.7-3.7,16.3-14.1,19.7-20.3
                c2.7,5.3,6,9.9,10.7,14.9c1.3,1.4,2.2,2,3.3,2.8c0.4,0.3,0.9,0.6,1.5,1.1l0.1,0.1l0.1-0.1c1.3-0.9,3.1-2.1,4.5-2.2l0,0
                c0.1,0,0.2,0,0.3,0c0.5,0,1.1,0,1.1-0.5c0-0.6-0.8-0.9-1.2-1c-4.8-1.7-14.3-8.6-19.2-16.8c0.1-0.1,0.2-0.1,0.3-0.2
                c0.6-0.3,1.5-0.8,1.7-1.5l0,0l0,0c-0.1-0.7-1.4-2-2.4-3c-0.3-0.3-0.6-0.6-0.7-0.7c-0.2-0.3-0.5-0.3-0.7-0.3c-0.1,0-0.3,0.1-0.3,0.2
                c-0.1,0.1-0.4,0.3-0.8,0.6c-0.7,0.5-1.5,1.1-1.8,1.4l-4.4,0l-3.9-0.5l2.3,3.4l1.1-0.9h5.1c-3.2,8.8-13.6,20.5-17.1,23
                c-0.1,0-0.1,0.1-0.1,0.2C216.1,29.1,216.2,29.3,216.4,29.4z"/>
            </g>
            <g>
              <path d="M305,4.4c0.4,0.9,0.5,1.9,0.6,2.9l0,0.1c0.1,1.4,0.5,2.7,2.5,2.7c0.6,0,1.4-0.1,1.8-1c0.3-0.5,0.4-1.1,0.4-1.6
                c0-1.3-0.7-2.4-1.9-3.3c-0.2-0.1-1-0.8-1.5-1l-1.3-0.5l-0.1,0c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.5,0.2-0.5,0.4
                c0,0.1,0.2,0.4,0.4,0.8C304.7,3.8,305,4.2,305,4.4z"/>
              <path d="M276.5,10.7h2.7v10.4h-2c-0.7,0-1.4-0.1-2.1-0.2c-0.4,0-0.7-0.1-1-0.1l-0.3,0l2.1,3.2l1-0.7h2.3v10.5
                c-1.7,0.5-3.3,0.9-5,1.2l-0.1,0l2.1,6.8l0.1-0.1c1.8-1.6,3.7-3.1,5.8-4.6c1.1-0.8,2.3-1.6,3.3-2.4c1.5-1.1,3.1-2.2,4.7-3.3
                c0.1-0.1,0.4-0.3,0.4-0.6c0-0.2-0.2-0.4-0.4-0.4c-0.1,0-0.9,0.2-3.9,1.2c-1.1,0.4-2.2,0.7-2.6,0.8v-9.3h4.6c0.5,0,0.8-0.2,0.8-0.6
                c0-0.6-2.4-3.7-3.1-3.7c-0.4,0-1.2,0.9-1.9,1.9c-0.1,0.1-0.2,0.2-0.2,0.3h-0.3v-9.7l0.7-0.7h4.8c0.5,0,0.9-0.2,0.9-0.6
                c0-0.7-2.8-3.8-3.5-3.8c-0.5,0-1.3,1-2.1,2.1c-0.1,0.1-0.1,0.2-0.2,0.2h-7.3c-0.7,0-1.4-0.1-2.1-0.2c-0.4,0-0.7-0.1-1-0.1l-0.3,0
                l2,3.2L276.5,10.7z"/>
              <path d="M290.6,25.3c0,0.9,0.5,2.4,1.7,2.4c1.8,0,2.8-1,2.8-2.7c0-2.4-1.5-4.6-3.9-5.8c0,0-1.3-0.8-1.7-0.8
                c-0.2,0-0.3,0.3-0.3,0.5c0,0.2,0.2,0.6,0.5,1.1c0.2,0.3,0.3,0.5,0.4,0.7c0.2,0.4,0.5,2.2,0.5,2.8c0,0.3,0,0.6,0,0.9
                C290.6,24.7,290.6,25,290.6,25.3z"/>
              <path d="M315.1,41.2c-0.9-1-2.1-2.4-3.2-3.9c-2.1-2.9-4-6.4-5.2-9.2c1.9-1.6,3.7-3.4,5.7-5.4l0.1,0
                c0.5-0.1,1.3-0.3,1.3-0.9c0-0.8-4.4-3.5-5-3.5h-0.1l0,0c-0.1,0.1-0.1,0.4-0.1,0.6c-0.1,0.5-0.2,1-0.3,1.5l-0.1,0.3
                c-0.5,1.9-1.4,3.6-2.4,5.5c-1.6-4-2.8-7.9-3.3-11.5h10.7c0.4,0,0.8-0.2,0.8-0.5c0-0.5-3.1-3.8-3.8-3.8c-0.4,0-1,0.7-2.1,1.9
                c-0.1,0.2-0.2,0.3-0.3,0.3H302V4.1l0.1-0.1c0.5-0.4,1.1-0.9,1.1-1.6c0-0.9-5.3-1.9-5.9-1.9c-0.5,0-0.5,0.3-0.5,0.5
                c0,0.1,0.1,0.4,0.3,0.8c0.2,0.5,0.4,1,0.4,1.4c0.1,0.6,0.2,1.2,0.2,1.8v7.5c-2.3,0-6.7,0.1-9.6-0.4l-0.3,0l2.1,3.2l1-0.7h6.8v12.5
                l-0.4,0.4c-3.6,3.7-7.7,7.9-12.3,10.4l-0.1,0.1l4,5.3l0.1-0.2c1.8-3,3.8-5.9,5.7-8.8c1-1.5,2-3,3-4.6v13.3c0,1.2-0.1,2-1.3,2
                c-1.1,0-2.2-0.1-3.4-0.3c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.2,1.8,1.2
                c2.1,1.1,2.4,2,2.7,4.2l0,0.1l0.2,0c1.8-0.3,4.8-0.7,5.5-2.9c0.2-0.5,0.2-1.4,0.2-2V20.1c0.9,5.3,1.9,10.8,3.9,16.1
                c0.8,2.2,1.7,4.4,3,6.6l0.1,0.1l0.1,0c1.1-0.5,2.4-0.8,3.5-0.8c0.4,0,0.8,0,1.2,0.1c0.4,0,0.8,0.1,1.2,0.1c0.3,0,0.5-0.1,0.5-0.3
                C315.4,41.6,315.3,41.4,315.1,41.2L315.1,41.2z"/>
            </g>
            <g>
              <path d="M348.9,49h22.9c0.3,0,0.8-0.2,0.8-0.6c0-0.8-2.8-3.5-3.4-3.5c-0.4,0-1.2,0.9-2,1.9c-0.1,0.1-0.1,0.1-0.2,0.2
                h-6v-11l0.5-0.6h7.5c0.4,0,0.6-0.4,0.6-0.7c0-0.5-0.4-1-0.8-1.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.8-0.9-1.6-1.8-2.3-1.8
                c-0.4,0-1,0.6-2.1,2l-0.1,0.1h-12.4c-0.6,0-1.3-0.1-1.9-0.2c-0.3,0-0.6-0.1-0.9-0.1l-0.3,0l2.2,3.3l0.8-0.9h4.9v11.7H349
                c-0.5,0-1.1-0.1-1.7-0.1c-0.4,0-0.8-0.1-1.2-0.1l-0.3,0l2.2,3.2L348.9,49z"/>
              <path d="M349.7,7.4h21.1c0.3,0,0.6-0.2,0.8-0.5l0,0v0c0-0.8-3.1-3.7-3.7-3.7c-0.3,0-1,0.6-2.3,2
                c-0.1,0.1-0.1,0.1-0.1,0.1h-15.7c-0.7,0-1.5-0.1-2.2-0.2c-0.2,0-0.5-0.1-0.7-0.1l-0.3,0l2.2,3.3L349.7,7.4z"/>
              <path d="M333.6,46.8c1.1,0,1.9-0.4,2.3-1.3c0.5-1.1,0.7-2,0.7-2.9c0-1.9-0.7-5.3-2-6.8l0,0c-0.1-0.1-0.2-0.2-0.5-0.2
                c-0.1,0-0.1,0-0.2,0.1c-0.2,0.2-0.2,0.7-0.2,1.3c0,0.1,0,0.1,0,0.1c0,0.9,0,2-0.4,2.8c-0.2,0.5-0.4,0.9-0.7,1.4
                c-0.6,1.1-1.2,2.2-1.2,3.4C331.6,46.2,332.2,46.8,333.6,46.8z"/>
              <path d="M333.5,21.6c2-0.9,4-1.8,6-2.6c-1,2.1-3.5,6.5-4.9,8c-0.7,0.7-1.4,1.2-2.1,1.4l-0.1,0l2.5,5.5l0.1-0.1
                c0.4-0.3,0.8-0.5,1.2-0.7c2.7-1.6,4.8-2.9,7.8-4.1c0,0.1,0,0.2,0,0.3c0.2,1.4,0.4,3,2.3,3c1.3,0,2.2-1.2,2.2-2.4c0-2-1.5-4.1-3-5.4
                c-0.2-0.2-1.9-1.7-2.7-1.7c-0.3,0-0.4,0.1-0.4,0.3c0,0.1,0.1,0.3,0.4,0.8c0.1,0.1,0.2,0.3,0.2,0.3c0.4,0.7,0.7,1.8,0.8,3.1
                c-2.5,0.4-4.7,0.7-6.9,0.9l2.6-3.2c0.9-1.2,1.8-2.5,2.7-3.7l-0.1-0.1l0.1,0.1l4.9-6.7c0.1,0,0.1,0,0.3-0.1c1.1-0.3,1.7-0.6,1.7-0.9
                c0-0.8-4.5-4.1-5.2-4.1c-0.2,0-1.2,3.1-1.2,3.1c-0.6,1.4-1.3,2.8-2.1,4.3c-1.3,0.1-2.7,0.2-4,0.2l-0.9,0c2.7-3.5,4.9-6.7,7.4-10.6
                c0,0,0.1,0,0.2-0.1c1-0.3,1.6-0.6,1.6-0.9c0-0.5-0.3-0.8-0.6-0.9c-0.6-0.5-4.3-2.9-5.1-2.9c-0.3,0-0.3,0.5-0.3,0.8
                c-0.2,1.2-0.5,2.2-0.8,3.1c-0.8,2.4-3.3,9.1-4.5,10.3c-0.5,0.5-0.7,0.5-1.3,0.8l-0.2,0.1l1.5,4.8L333.5,21.6z"/>
              <path d="M369.5,14.1L369.5,14.1c0.9-0.1,1.8-0.3,1.8-0.9c0-0.7-4.1-4.1-4.6-4.1h-0.1l0,0.1c0,0-0.8,2.5-0.8,2.6
                c-0.8,2.5-2.3,5.2-4.4,8.3l-0.1,0.1l0.1,0.1c1.1,1,1.8,1.9,2.4,2.9c0.6,1,1.1,2.2,1.3,3.6c0,0.2,0.1,0.3,0.1,0.5
                c0.3,1.4,0.7,3.6,2.6,3.6c1.6,0,2.1-1.9,2.1-3.2c0-3.2-3.1-5.4-5.5-7.1c-0.3-0.2-0.5-0.4-0.8-0.5c0.6-0.6,1.1-1.1,1.7-1.6
                C366.6,17,368.1,15.6,369.5,14.1z"/>
              <path d="M344.1,38.6c0.1,1.2,0.3,2.4,0.9,3.1c0.3,0.4,0.9,0.6,1.5,0.6c1.5,0,2.2-1.3,2.2-2.6c0-1.6-1-2.7-1.9-3.6
                c-0.6-0.6-3.2-2.8-4.3-2.8c0,0-0.1,0-0.1,0l-0.1,0v0.1c0,0.2,0.2,0.6,0.7,1.4c0.3,0.4,0.5,0.9,0.6,1.1
                C343.9,36.8,344,37.7,344.1,38.6z"/>
              <path d="M352.4,8.2c-0.1,0-0.3,0-0.8,2.1l0,0.1c-0.2,0.9-0.5,1.8-0.9,2.7l0,0c-0.9,2.5-2.1,5-3.6,7.3l0,0.1l0.1,0.1
                c1.1,1.2,1.6,1.8,2.3,3.2c0.6,1.1,0.9,2.4,1.2,3.8c0,0.2,0.1,0.3,0.1,0.5c0.2,1.6,0.6,3.9,2.7,3.9c1.5,0,2-1.7,2-2.8
                c0-3.6-2.9-6-5.4-8.1c-0.2-0.2-0.4-0.3-0.6-0.5l1.6-1.8c1.3-1.5,2.8-3.6,3.9-5.3l0.2-0.2l0,0c0.8-0.1,1.8-0.3,1.8-0.8
                C356.9,11.6,352.9,8.2,352.4,8.2z"/>
              <path d="M359.8,8.3c-0.3,0-0.5,0.4-0.7,1.5l0,0.1c-0.3,1.1-0.8,2.3-1.3,3.4c-0.1,0.3-0.2,0.5-0.3,0.8
                c-0.9,1.9-2,3.7-3.3,5.6l-0.1,0.1l0.1,0.1c1.1,1.1,1.6,1.9,2.3,3.2c0.6,1.2,1,2.5,1.2,3.8c0,0.2,0.1,0.4,0.1,0.6
                c0.3,1.7,0.6,3.8,2.8,3.8c1.6,0,2-2,2-3.1c0-3.1-3.2-5.9-5.5-7.9c-0.2-0.2-0.4-0.3-0.6-0.5l1.6-1.6c0.4-0.4,0.7-0.7,1-1.1
                c0.1-0.2,0.3-0.3,0.4-0.5c0.9-1.1,1.8-2.2,2.7-3.3l0.1-0.1c1.2-0.2,1.8-0.5,1.8-0.9C364.3,11.7,360.3,8.3,359.8,8.3z"/>
              <path d="M337.8,35.3c-0.1-0.1-0.4-0.3-0.8-0.2l-0.1,0v0.1c0,0.3,0.3,1,0.7,1.6c0.2,0.3,0.3,0.6,0.4,0.8
                c0.4,1.1,0.5,2.4,0.6,3.7l0,0.5c0.1,0.6,0.2,1.5,0.7,1.9c0.4,0.3,0.9,0.4,1.3,0.4c1.4,0,2.3-1,2.3-2.6
                C342.9,39.2,339.9,36.5,337.8,35.3z"/>
            </g>
            <g>
              <path d="M412,4.9c0.1,0.5,0.3,1,0.5,1.5c0.4,0.9,1.2,1.4,2,1.4c1.5,0,2.3-1.4,2.3-2.7c0-1.7-1-2.9-3.1-3.8
                c-0.8-0.3-3.3-1.4-4.1-1.4c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.2,0.3C411.1,2.2,411.4,2.9,412,4.9z"/>
              <path d="M423.7,16.1l2.3-0.5c0.4,0.1,0.7,0.2,1.1,0.2c0.4,0,0.8-0.2,0.8-0.6c0-0.5-2.7-3-3.3-3c-0.2,0-0.3,0.2-0.4,0.4
                c0,0,0,0.1-0.1,0.1l0,0c-0.3,0.7-3,2.5-4,3.1c-0.2,0-0.3-0.1-0.5-0.1c-0.4-0.1-0.8-0.2-1.2-0.2c-0.3,0-0.5,0.2-0.5,0.4
                c0,0.2,0.1,0.4,0.2,0.5c0.2,0.3,0.3,1.2,0.3,1.9v5.3c0,1.1-0.3,1.7-0.8,2.1l-0.1,0.1l2.4,3.9l0.1-0.1c1.6-1.8,2.9-3.2,4.1-4.5
                l1.4,3.2l0.1-0.1c1.4-0.8,2-0.8,3.6-0.8c0,0,0.1,0,0.1,0c0.4,0,0.9,0,1.1-0.2c0.1-0.1,0.1-0.1,0.1-0.2c0-0.2-0.1-0.3-0.2-0.5
                c-1-0.9-2.2-2-3.2-3.4C425.3,20.6,424.4,18.9,423.7,16.1z M421.7,24.3v-7.1l0.3-0.7l0.5-0.2l0,0.5c0.2,2.3,0.5,4.5,1.1,6.6
                L421.7,24.3z"/>
              <path d="M389,15.9L389,15.9L389,15.9c1.2,1.3,2.2,2.3,2.5,4c0,0.2,0.1,0.3,0.1,0.5c0.3,1.3,0.6,3,2.4,3
                c1.4,0,2.5-1,2.5-2.4c0-0.9-0.4-1.7-0.8-2.4c-0.6-0.9-1.5-1.7-2.8-2.2c-0.1,0-0.3-0.1-0.5-0.2c-1.3-0.5-2.7-0.9-3.2-0.9
                c-0.3,0-0.4,0.1-0.4,0.3C388.9,15.7,389,15.8,389,15.9C389,15.9,389,15.9,389,15.9z"/>
              <path d="M395.5,8.3l0.1,0.3c0.1,0.4,0.3,0.8,0.4,1.2c0.4,0.8,1.2,1.4,2,1.4c1.4,0,2.3-1.1,2.3-2.6c0-1.8-1-3-3.2-3.9
                c-0.8-0.3-3.3-1.3-3.8-1.3c-0.2,0-0.5,0.1-0.5,0.3c0,0.1,0.1,0.2,0.2,0.3C394.6,5.6,394.9,6.2,395.5,8.3z"/>
              <path d="M403.5,9.9h13.9c-0.1,0.1-0.1,0.4-0.2,0.6c0,0.1,0,0.2,0,0.2l0,0c-0.1,0.9-1.7,4.6-2,5.4c-0.1,0-0.2,0-0.4-0.1
                c-0.6-0.1-1.4-0.3-2-0.3c0.7-0.2,1.5-1,1.5-1.8c0-1.7-2-2.9-3.8-3.5l-0.1,0c-0.3-0.1-0.8-0.3-1.3-0.2l-0.1,0v0.1
                c0,0.2,0.2,0.5,0.5,0.8c0.1,0.1,0.1,0.1,0.1,0.2c0.5,0.7,0.9,1.3,1,1.9c0.3,1.1,0.8,2.4,1.8,2.5c-0.2,0-0.3,0.1-0.4,0.3
                c-0.5-0.7-2.9-2.6-3.2-2.6c-0.3,0-1.1,1.1-1.3,1.4h-4.9c-0.5,0-1-0.1-1.5-0.1c-0.3,0-0.6-0.1-0.9-0.1c0.1-0.2,0.1-0.4,0.1-0.7
                c0-0.2-0.3-0.4-0.5-0.4c-0.3,0-0.6,0.7-1.1,2.6c0,0.1-0.1,0.3-0.1,0.3c-0.4,1.4-0.8,2.9-1.2,4.3c-0.4,1.4-0.8,2.9-1.2,4.3l-1.6,4.9
                c-0.1,0.2-0.2,0.6-0.3,0.9c-0.4,1.2-1,3.3-1.5,3.7c-0.5,0.4-1.4,0.5-2,0.5c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.4-0.1-0.6-0.1
                c-0.3,0-0.5,0-0.5,0.4c0,0.3,0.5,0.6,1.1,0.9c0.9,0.4,2.1,1,2.5,2c0.5,1.2,0.5,3.5,0.5,4.8c0,0.1,0,0.3,0,0.4c0,1.4,0,3.6,1,4.6
                c0.4,0.4,1,0.6,1.6,0.6c1.6,0,2.6-1.2,2.6-2.9c0-1.2-0.3-2.5-0.6-3.7c-0.1-0.2-0.1-0.5-0.2-0.7c-0.6-2.3-0.8-4.3-0.8-6.3
                c0-2.2,0.4-4.4,0.8-6.6l0.1-0.7v0c0.4-2.5,0.9-5.1,1.3-7.6c0.3-1.6,0.6-3.2,0.9-4.8l1.2,1.9l1-0.7h0.3v1.1c0,3.2-1.2,7.7-2.7,10.3
                c-0.2,0.2-1.2,1.9-1.2,2.1c0,0.1,0,0.2,0.3,0.4l0.1,0c0.2,0,0.5-0.2,1.1-0.7c0.1-0.1,0.1-0.1,0.2-0.2c1.2-1,2.3-2.1,3.2-3.6
                c1.6-2.4,1.9-4.6,2.4-7c0.1-0.6,0.2-1.2,0.4-1.9l0.5-0.6h1.1l-0.2,3.3l-0.2,2.8c-0.1,1.5-0.4,2.5-1.7,2.5c-0.2,0-0.4,0-0.6,0
                c-0.2,0-0.4,0-0.6,0c-0.3,0-0.6,0.2-0.6,0.4c0,0.2,0.3,0.4,0.7,0.8c0.4,0.3,0.8,0.6,0.9,0.9c0.3,0.5,0.3,1.1,0.4,1.7
                c0,0.1,0,0.2,0,0.3l0,0.2l0.1,0c4.2-1.2,4.3-2.6,4.6-6.2c0-0.3,0-0.6,0.1-1c0.1-1.7,0.2-3.3,0.2-4.9l0,0c0.5-0.3,1-0.6,1.2-0.9
                c0,0.1,0.1,0.2,0.1,0.4c0.1,0.3,0.3,0.7,0.3,1l0,0.1c0,0.4,0.1,0.8,0.1,1.2V26c0,1-0.1,2.2-0.2,3.2c0,0.3-0.1,0.6-0.1,1l0,0.2
                l0.7-0.2c1.1-0.4,2.2-0.7,3.3-1.2l0.1,0l0-0.1c0-0.4,0-0.8-0.1-1.2c0-0.8-0.1-1.6-0.1-2.4v-6.9c0.4-0.2,0.9-0.6,0.9-1
                c0-0.4-0.4-0.6-0.8-0.7c0.5-0.4,0.9-0.8,1.4-1.3c0.7-0.7,1.5-1.4,2.4-2c0.7,0,1.6-0.2,1.6-0.9c0-0.8-2.7-2.1-3.8-2.5h10.7
                c0.4,0,0.7-0.2,0.7-0.5c0-0.5-2.8-3.4-3.4-3.4c-0.3,0-1.7,1.4-2.3,2h-19.8c-0.6,0-1.2-0.1-1.7-0.1c-0.4-0.1-0.9-0.1-1.3-0.1l-0.2,0
                l1.9,2.9L403.5,9.9z"/>
              <path d="M419.4,46.1c0,0.9-0.1,1.8-0.1,2.8c0,0.6-0.1,1.3-0.1,2l0,0.2l0.2,0c1.4-0.3,3-0.8,4.5-1.4l0.1,0l0-0.1
                c0-0.7-0.1-1.3-0.1-2c-0.1-0.9-0.1-1.8-0.1-2.6V33.4l0,0c0.5-0.4,1-0.9,1-1.3c0-1-4.6-2.1-5.3-2.1c-0.3,0-0.5,0.2-0.5,0.4
                c0,0.2,0.1,0.4,0.2,0.6c0.1,0.3,0.3,0.7,0.3,1.2v0.6H409c0.3-0.2,0.7-0.6,0.7-0.9c0-1.1-5.3-2.1-5.4-2.1c-0.2,0-0.5,0-0.5,0.4
                c0,0.2,0.1,0.4,0.2,0.7c0.1,0.2,0.2,0.5,0.2,0.7c0.1,1,0.1,2.1,0.1,3.2c0,3.3-0.4,9.4-3.2,12.5c-0.7,0.8-1.4,1.7-2.3,2.5l-0.1,0.1
                c-0.1,0.1-0.3,0.3-0.3,0.5c0,0.2,0.2,0.4,0.4,0.4c0.4,0,1.6-0.8,2.7-1.5c0.1-0.1,0.2-0.2,0.3-0.2c3.8-2.7,4.8-4,6-8.3h11.5V46.1z
                M419.4,34.7v4.1h-11.3c0.1-1.4,0.2-2.7,0.3-4.1H419.4z"/>
            </g>
            <g>
              <path d="M212,123.2c-0.1-1.4-0.3-2.7-0.3-4.1v-4.6c0.5-0.3,1.7-0.9,1.7-1.5c0-1.2-5.1-2.4-6.3-2.4
                c-0.3,0-0.7,0-0.7,0.4c0,0.4,0.3,0.9,0.3,1.4c0.2,0.4,0.1,1,0.1,1.4c0.1,0.9,0.3,1.9,0.3,2.8v2.3h-4.1v-6.3
                c0.4-0.3,1.4-0.8,1.4-1.4c0-1.3-5.7-2.6-6.5-2.6c-0.3,0-0.8,0.3-0.8,0.6c0,0.3,0.2,0.5,0.3,0.8c0.5,1.2,0.5,4.2,0.5,5.6v12.9
                c0,2.2-0.3,4.5-0.3,6.7c1.9-0.3,3.8-0.7,5.7-1.3c-0.1-1.4-0.3-3-0.3-4.4v-7.8h3.9l-0.2,2.9C208.3,124.1,210.3,123.9,212,123.2z"/>
              <path d="M219,62c-0.7,0-2.5,2.9-2.7,3.1H206c-0.8-0.4-6.5-3.5-7.4-3.5c-0.3,0-1-0.1-1,0.4c0,0.7,0.6,2,0.7,3
                c0.2,2.2,0.4,4.5,0.4,6.7v9.5c0,2.1-0.2,4.3-0.3,6.5c2.3-0.3,4.6-0.6,6.7-1.1v-0.9h12.3v42c0,1.9-0.3,3.1-2.3,3.1
                c-1.9,0-3.9-0.4-5.8-0.4c-0.3,0-0.8,0.2-0.8,0.6c0,0.3,0.3,0.4,0.4,0.5c1.2,0.5,2.5,1,3.5,1.9c1.4,1.4,1.8,3.6,1.9,5.5
                c1.6-0.2,8-1,8.9-2.6c1.1-2.1,0.8-4.7,0.8-7V69c0.4-0.3,2.4-1.6,2.4-2.4C226.5,65.9,220,62,219,62z M217.4,82.7h-12.3v-5.7h12.3
                V82.7z M217.4,74h-12.3v-4.8l0.8-1.1h11.5V74z"/>
              <path d="M207.6,90.8c0-1-4-2.8-5.5-3.3c-0.1,0.8-0.4,1.4-0.7,2c-1.2,2.9-1.9,4.1-4.6,5.7l1.2,4.3c2-0.7,4-1.2,6.2-1.6
                c-2.1,2.1-4.2,4.3-7.1,5.3l2.3,4.7c3.4-1.1,6.8-2,10.3-2.9c0.5,1.6,0.8,5.1,3.1,5.1c1.7,0,2.8-1.6,2.8-3.1c0-1.9-0.9-3.2-2.4-4.3
                c-1.1-0.8-3.8-2.4-5.1-2.4c-0.3,0-0.4,0.1-0.4,0.3c0,0.3,1.3,2.1,1.6,2.7l-7.7,0.6c3.5-2.4,7-5,10.4-7.6c0.6-0.1,2.3-0.3,2.3-1.1
                c0-0.8-4.1-4.1-4.8-4.1c-0.2,0-0.3,0.1-0.4,0.3c-0.3,1.4-1.9,3.4-3,4.3l-5.3,0.4c1.5-1.4,3-2.9,4.6-4.3
                C205.7,91.9,207.6,91.5,207.6,90.8z"/>
              <path d="M189.8,108.1c-0.3,0-0.4,0.1-0.6,0.3c0.1,1.1,0.3,2.3,0.3,3.4c0,2.4-0.3,4.6-0.6,6.9h-3.3v-5.6
                c0.4-0.3,1.3-0.8,1.3-1.4c0-1-5.1-2.1-5.8-2.1c-0.3,0-0.5,0.2-0.8,0.6c0,0.3,0.1,0.5,0.2,0.8c0.3,1,0.4,2.3,0.4,3.4v3.9
                c-0.3,0.2-1.9,0.8-1.9,1.3c0,0.5,3.5,4.2,4.3,4.2c0.7,0,2-1.9,2.4-2.2h2.8L188,123c-1.3,3.5-6.1,7.9-8.9,10c-0.3,0.3-1.7,1-1.7,1.4
                c0,0.3,0.3,0.5,0.5,0.5c0.4,0,1.6-0.6,2-0.8c3.8-1.6,10-4.5,11.9-8.4c2.5-5.5,2.6-7.9,2.9-13.7c0.3-0.3,1.4-0.9,1.4-1.4
                C196.1,109.6,190.6,108.1,189.8,108.1z"/>
              <path d="M191.1,100.2c-0.3,0-0.4,0.1-0.4,0.3c0,0.3,0.9,1.9,1.1,2.5l-7,0.8c3.1-2.4,6.3-4.6,9.4-7.2
                c0.3-0.1,2-0.3,2-0.8c0-0.8-3.5-4-4.3-4h-0.3c-0.4,1.3-1.4,2.7-2.4,3.6l-5.7,0.3c1.7-1.3,3.4-2.5,5.1-3.9c0.7,0,2.1-0.2,2.1-1.2
                c0-0.8-4.1-2.9-5.1-2.9c-0.1,0-0.3,0.1-0.3,0.1c-0.6,3-3.8,6.1-6.6,7l1.2,4.6c2.3-0.8,4.5-1.3,6.8-1.7c-3,2.7-5.1,4.6-9,5.5
                l2.3,5.7c3.9-1.9,8.1-3.2,12.3-4.5c0.2,1.4,0.4,3.4,2.2,3.4c1.6,0,2.4-1.9,2.4-3.2C196.8,102.8,192.7,100.2,191.1,100.2z"/>
              <path d="M174.4,85.4h10.9l-0.3,2.3c2.4-0.3,4.8-0.8,7.1-1.7c-0.4-5.7-0.3-11.6-0.3-17.3c0.3-0.3,2.4-1.9,2.4-2.4
                c0-0.8-6.2-4.5-7.3-4.5c-0.8,0-2.3,2.4-2.6,3h-8.5c-1-0.5-7-3.4-8-3.4c-0.3,0-0.6,0-0.8,0.5c0,0.3,0.2,0.8,0.3,1.1
                c0.3,1.2,0.5,2.4,0.6,3.5c0.2,2.3,0.3,4.5,0.3,6.7v53.1c0,4.1-0.4,8.3-0.6,12.3c2.4-0.7,5-1.3,7.4-2.1c-0.2-3.2-0.5-6.5-0.5-9.7
                V85.4z M174.4,69.2l0.7-1.4h10.3v6h-11.1L174.4,69.2z M174.4,76.7h11v5.6h-11.1L174.4,76.7z"/>
            </g>
            <g>
              <path d="M312.3,132.2c-1.4,0.1-2.9,0.2-4.3,0.2c-2.7,0-5.4-0.2-8.2-0.5c-8.6-0.9-12.8-2.8-18.9-9l1.3-3.5
                c2-5.7,3-12.8,3.6-18.8c0.5-0.3,2.3-1.2,2.3-1.9c0-0.4-0.4-0.8-0.8-1c-0.8-0.7-4-3.7-4.8-3.7c-0.8,0-1.9,1.4-2.4,1.9H279l5.4-20.8
                c0.7-0.5,2.1-1.3,2.1-2.2c0-0.7-4.9-4-5.5-4c-0.6,0-2.2,2-2.6,2.4c-2.5,0.2-5.2-0.2-7.8-0.4l2.7,4.5l1.4-1.1h3.8l-4.8,20.5
                c-0.6,0.3-2,0.9-2,1.7c0,0.4,0.2,0.7,0.4,0.8c0.7,0.7,3.2,3.3,4,3.3c0.7,0,2-1.4,2.5-1.9h1.4c-0.5,6.5-1.2,12.5-3.1,18.7
                c-1.3-2.7-2.4-4.9-3.2-7.8c-0.2-0.5-0.4-2.5-1.1-2.5c-0.5,0-0.7,0.4-0.7,0.8c0,1.4,0.3,2.9,0.4,4.2c-0.9-0.5-4.9-3-5.7-3
                c-0.1,0-0.3,0-0.4,0.1c-0.1,0.2-0.1,0.3-0.1,0.5c0,3.8-1.6,7.8-2.9,11.3v-16.6h9.3c0.5,0,1.1-0.4,1.1-1c0-0.9-3.8-5-4.4-5
                c-0.8,0-2.7,2.5-3.2,3.1h-2.8V90.4l1-1h6.2c0.7,0,1.3-0.3,1.3-1c0-1.1-3.5-4.7-4.1-4.7c-0.6,0-2.7,2.4-3.2,2.9h-7.3
                c-0.8,0-1.8-0.2-2.6-0.2c3.1-5.2,6.2-10.3,8.9-15.8c1.4,1.9,2.4,4.1,3,6.4c0.3,0.9,0.5,1.9,1,2.7c0.4,0.8,1.3,1.1,2.1,1.1
                c2,0,3-1.9,3-3.7c0-3.6-5.7-6.6-8.4-8.1l0.8-1.8c0.8-0.1,2.5-0.4,2.5-1.4c0-1.4-7.6-5.3-8.9-5.3c-0.2,0-0.3,0-0.4,0.1
                c-0.3,0.8-0.4,2.4-0.5,3.4c-0.1,1.9-0.7,3.9-1.1,5.7c-1,4.1-2.4,8-4,11.9c-1.3,3.5-2.7,6.9-4.3,10.3c-0.3,0.5-1.3,2.8-1.3,3.3
                c0,0.3,0.2,0.6,0.4,0.6c0.7,0,4.5-5.5,5.1-6.5l1.1,1.2l1-1h2.9v12.1c-3,0.1-6.2-0.1-9.3-0.4l2.8,4.5l1.3-1.2h5.1v22.3
                c-3,0.5-6.2,0.8-9.4,1.1l3.5,7.6c2.3-1.3,4.8-2.4,7.2-3.6c4-1.9,7.9-3.5,11.8-5.6l1.4-0.8c0.3-0.1,0.5-0.3,0.5-0.5
                c0-0.3-0.3-0.6-0.6-0.6c-0.8,0-1.6,0.3-2.3,0.4c-2.2,0.3-4.4,0.6-6.6,0.8v-1.9l7.5-9.3l1.9-0.8c0.8,3.5,1.4,5.7,2.7,8.8
                c-3,7.3-5.1,10.6-10.5,16.4c-0.3,0.3-0.5,0.6-0.5,0.8c0,0.3,0.3,0.5,0.6,0.5c0.5,0,2.4-1.4,3-1.8c4.2-2.7,7.6-6.5,10.5-10.6
                c1.5,1.9,3.2,3.8,5.1,5.3c5.3,4.3,16.9,6.2,23.5,7.3c0.8-2.7,1.2-4,3.5-5.6c0.3-0.3,2.3-1.4,2.3-1.8S312.8,132.1,312.3,132.2z"/>
              <path d="M310.3,80.8c-0.4,0-2.3,2.3-2.5,2.4v-7.8c0.6-0.4,1.9-1.1,1.9-2c0-0.5-0.4-0.9-0.8-1.3c-0.6-0.4-3.5-3-4.4-3
                c-0.7,0-2.5,2-2.8,2.4h-3.5l-0.1-6.2c0.7-0.3,1.9-0.8,1.9-1.6c0-2-6.1-3.5-7.6-3.5c-0.4,0-0.8,0.1-0.8,0.6c0,0.4,0.3,0.8,0.4,1.2
                c0.4,0.8,0.5,1.6,0.6,2.5c0.1,1,0.2,2,0.2,3.1v4l-6.2-0.4l2.8,4.4l1.3-1.2l2.1,0.1l-0.1,8.8c-1,0.1-2,0.1-3,0.1
                c-1.8,0-3.7-0.3-5.6-0.3l2.8,4.4l1.3-1.1h4.6v8.3l-6.4-0.4l2.7,4.5l1.4-1.2h2.3v8.6c-2.4,0.2-4.8-0.2-7.2-0.4l2.8,4.4l1.3-1.1h3
                v7.1h-3.1c-1.8,0-3.7-0.3-5.6-0.4l2.8,4.5l1.3-1.2h4.6c0.2,3.5-0.2,7.1-0.5,10.6c2.1-0.3,4.6-0.7,6.4-1.6c-0.2-2-0.4-4.2-0.4-6.2
                v-2.7h11c0.6,0,1-0.3,1-0.9c0-0.4-0.2-0.8-0.4-1.2c-0.5-0.5-2.7-3.6-3.6-3.6c-0.8,0-2.6,2.4-3.1,3l-4.8-0.1v-7.1h9.9
                c0.6,0,0.8-0.4,0.8-1c0-0.4-0.2-0.8-0.5-1.1c-0.4-0.4-3.3-3.6-4-3.6c-0.6,0-2.7,2.4-3.1,2.9h-3v-8.6h4.1l-0.2,2.9
                c2.4-0.3,3.7-0.5,6-1.6c-0.2-1.8-0.4-3.6-0.4-5.3v-7.1h5.3c0.7,0,1.1-0.4,1.1-1.1C314.2,84.2,310.8,80.8,310.3,80.8z M302.4,94.5
                h-4.1v-8.3h4.1V94.5z M302.4,83.3h-4.1v-8.9h4.1V83.3z"/>
              <path d="M253,122.7c2.5,0,3.6-1.3,3.6-3.7c0-3.4-2.4-6.6-4.7-8.6c-0.3-0.2-0.9-0.9-1.2-0.9c-0.3,0-0.5,0.3-0.5,0.5
                c0,0.2,0.8,2.3,0.8,2.6c0.3,1,0.4,2,0.4,3c0,1.5-0.3,3-0.3,4.5C251.2,121.3,251.6,122.7,253,122.7z"/>
            </g>
            <g>
              <path d="M334.7,87.6h29.4c0.6,0,1.4-0.2,1.4-0.8c0-0.8-0.9-1.7-1.4-2.2c-0.5-0.5-2.6-3.1-3.6-3.1c-0.8,0-3,2.8-3.4,3.1
                h-5.4v-8.9H363c0.5,0,1.1-0.3,1.1-0.8c0-1.1-4.3-5.1-5.1-5.1c-0.7,0-2.9,2.7-3.1,3h-4.2l-0.1-7.8c0.3-0.3,2.3-1.4,2.3-2.1
                c0-0.4-0.6-0.7-0.9-0.8c-1.5-0.6-6.7-2.4-8.3-2.4c-0.3,0-0.7,0.2-0.7,0.5c0,0.4,0.8,2.2,0.9,3.1c0.2,0.9,0.2,1.9,0.2,2.9v6.8h-6.7
                c-1.5,0-3.2-0.2-4.7-0.3l3.1,4.7l1.3-1.4h7v8.9c-3.4,0-6.7,0.1-10,0.1c-1.5,0-3.2-0.3-4.7-0.4l3.1,4.6L334.7,87.6z"/>
              <path d="M338.3,89.3c-0.2,0-0.4,0.1-0.7,0.4c0.1,0.3,0.9,1.3,1.2,1.5c0.4,0.5,0.7,1.1,0.8,1.7c0.8,2.2,0.3,5.7,1.8,6.9
                c0.4,0.3,1,0.5,1.5,0.5c2.6,0,3.1-2.2,3.1-4.3c0-1.9-1.4-3.3-2.9-4.3C342.2,91,339.5,89.3,338.3,89.3z"/>
              <path d="M360.8,109.4c-0.6,0-3.4,3.1-3.5,3.3h-5.1v-7.7l0.7-1h10.7c0.6,0,1.2-0.3,1.2-0.9c0-1-4-4.9-4.8-4.9
                c-0.8,0-3,2.5-3.3,2.9h-4.1c1.9-2.7,3.6-5.4,5.3-8.2c0.4-0.2,3-1.1,3-1.9c0-0.6-1.6-1.1-2-1.3c-0.7-0.2-5.2-1.8-5.7-1.8
                c-0.4,0-0.5,0.6-0.5,0.9c0,4.3-1,8-2.1,12.2h-12.4c-1.5,0-3.2-0.3-4.8-0.4l3.2,4.7l1.2-1.4h7.7v8.7c-3,0-6,0-9,0
                c-1.5,0-3.2-0.3-4.8-0.4l3.2,4.7l1.2-1.3h9.4c0,4.9,0,9.8,0,14.8c0,2.9-0.3,5.8-0.5,8.7c2.7-0.6,5.2-1.6,7.8-2.5
                c-0.1-2.4-0.3-4.8-0.3-7.2v-13.8h12.6c0.6,0,1.1-0.3,1.1-0.9C365.7,113.8,361.5,109.4,360.8,109.4z"/>
              <path d="M396.2,131.7c-3.8-3.7-7.1-7.9-9.9-12.3c2.7-6,4.5-12.4,6.2-18.7c0.6-0.3,2.6-1.4,2.6-2.2
                c0-0.9-5.7-5.3-6.7-5.3c-0.7,0-2.8,3-3.1,3.4h-12.7V69.4l1-0.8H384c0,2.3,0,4.5,0,6.8c0,1.7-0.1,3.5-0.2,5.1
                c-0.1,2.9-0.5,4.2-3.7,4.2c-1.3,0-2.6-0.2-3.9-0.3c-0.4,0-0.8,0.2-0.8,0.6c0,0.4,2.1,1.2,2.4,1.4c2.5,1,2.8,3,3.2,5.4
                c2.2-0.2,6.3-0.8,7.6-2.9c2.1-3.5,1.9-9.8,1.9-13.8c0-1.9,0-3.7,0-5.6c0.7-0.4,2.4-1.2,2.4-2.2c0-1.2-5.7-4.9-6.7-4.9
                c-0.9,0-2.5,2.7-3,3.2h-9.8c-1.5-0.8-6.5-3.6-8.3-3.6c-0.4,0-0.6,0.2-0.6,0.6c0,0.4,0.3,0.8,0.4,1.2c0.4,0.8,0.6,1.8,0.8,2.7
                c0.2,1.1,0.3,2.3,0.3,3.4v61.4c0,2.8-0.3,5.7-0.5,8.5c2.4-0.7,5-1.5,7.3-2.5l-0.1-1.9c3.9-2.5,6.7-5.5,9.5-9.1
                c2,4.1,3.4,6.8,6.1,10.5c2.2-1.3,4.6-2.4,7.2-2.4c0.3,0,2.5,0.2,2.5-0.3C398.1,133.3,396.7,132.2,396.2,131.7z M372.7,134.1
                c-0.1-1.4-0.2-3-0.2-4.4V99.5h2.5c1,8,2.2,13.8,4.8,21.4C378.1,125.6,375.6,130,372.7,134.1z M382.5,113.1c-2.4-4.4-4-8.8-5.3-13.6
                h8.4C384.9,104.1,383.9,108.7,382.5,113.1z"/>
            </g>
            <g>
              <path d="M471,110c-0.8-0.5-4.6-3.4-5.8-3.4c-0.7,0-2.5,2.7-2.9,3.1h-23.7c-1.8-0.9-8.2-3.9-9.9-3.9
                c-0.3,0-0.7,0-0.7,0.4c0,0.8,0.5,1.4,0.8,2.2c0.3,1.4,0.3,5.5,0.3,7v16.5c0,2.4-0.3,4.9-0.4,7.3c2.7-0.2,5.3-0.6,7.9-1.4v-3.3H463
                l-0.4,4.8c2.9-0.5,5.7-1.3,8.4-2.4c-0.1-2.4-0.3-5.1-0.3-7.5v-15.4c0.5-0.4,2.2-1.5,2.2-2.4C472.9,111.1,471.4,110.2,471,110z
                M463,131.6h-26.3v-18.2l1-0.6H463V131.6z"/>
              <path d="M477.9,94.6c-0.5-0.5-1.7-1.7-2.4-1.7c-1.3,0-4.2,3.7-4.8,4.3H454c0-4.9,0-9.6,0-14.8h18.9
                c0.5,0,1.1-0.3,1.1-0.8c0-1.1-3.1-4-3.7-4.5c-0.5-0.6-1.4-1.5-2.3-1.5c-1.1,0-3.8,3.4-4.2,3.9H454V66.6c0.5-0.4,2.8-2.1,2.8-2.8
                c0-1.7-9.2-3.7-10.5-3.7c-0.3,0-0.9,0.2-0.9,0.6s0.3,0.8,0.4,1c0.4,0.8,0.5,1.9,0.6,2.8c0.2,1,0.2,2.1,0.2,3.2v11.7h-11.2
                c1.2-2.9,2.2-5.7,3.2-8.7c0.6-0.3,2.2-1,2.2-1.8c0-1.2-5.8-2.9-6.2-3c-1.1-0.5-2.9-1-4-1c-0.2,0-0.3,0.1-0.6,0.4
                c0,0.4,0.2,0.8,0.2,1.3c-0.3,6.1-1.3,12.2-2.7,18.1c-0.6,2.7-1.3,5.4-2.1,8.1c-0.1,0.5-0.8,2.3-0.8,2.6c0,0.3,0.3,0.5,0.5,0.6
                c0.5,0,1.8-2.1,2.1-2.5c2.6-3.5,4.6-7.3,6.8-11.2h12.6v14.8h-24.3c-1.6,0-3.5-0.3-5.1-0.5l3.4,4.6l1.5-1.1h24.5v3.4l-0.3,5.7
                l8.4-2.6l-0.5-2.8v-3.6h26.4c0.5,0,1-0.5,1-1.1C481.5,97.9,478.4,95.2,477.9,94.6z"/>
            </g>
          </g>
          <g :class="showSlogan ? 'fadein setanimate' : 'fadein'" :transform="`translate(0, ${setSvgTransform})`">
            <path d="M8,132.1h63.6c1.3,0,1.9,0.6,1.9,1.9v1.5c0,1.3-0.6,1.9-1.9,1.9H1.9c-1.3,0-1.9-0.6-1.9-1.9v-1.9
              c0-0.8,0.3-1.6,0.8-2.5l18.2-23.9l25.6-33.5c12.1-16.4,18.2-29.4,18.2-38.8c0-8-2.7-14.3-8-19.1c-5.3-4.8-12.3-7.2-21-7.2
              c-8.5,0-15.3,2.4-20.5,7.2c-5.2,4.8-7.7,11.2-7.6,19.1v6.3C5.7,42.4,5,43,3.8,43H1.9C0.6,43,0,42.4,0,41.1v-6.6
              c0.1-9.3,3.3-16.9,9.5-22.6c6.2-5.7,14.3-8.6,24.2-8.6c10.4,0,18.7,2.9,25.1,8.7c6.4,5.8,9.6,13.4,9.6,22.7c0,11.1-6.2,25-18.7,41.5
              c-1.4,1.9-10.6,14-27.6,36.2c-6.3,8.3-11.1,14.6-14.4,18.8C7.2,131.8,7.3,132.1,8,132.1z"/>
          </g>
          <g :class="showSlogan ? 'fadein setanimate' : 'fadein'" :transform="`translate(0, ${setSvgTransform2})`">
            <path d="M139,133.8c-9.3,0-16.9-2.7-22.5-8.1c-5.7-5.4-8.5-12.6-8.5-21.4V37.9c0-8.8,2.8-16,8.5-21.4
              c5.7-5.4,13.2-8.1,22.5-8.1c4.5,0,8.6,0.6,12.3,1.8V4.6c-3.8-1-7.9-1.5-12.3-1.5c-11.1,0-20,3.2-26.7,9.7c-6.7,6.4-10,15-10,25.6
              v65.6c0,10.6,3.3,19.1,10,25.6c6.7,6.4,15.6,9.7,26.7,9.7c4.5,0,8.6-0.5,12.3-1.5V132C147.6,133.2,143.5,133.8,139,133.8z"/>
          </g>
          <g :class="showSlogan ? 'fadein setanimate' : 'fadein'" :transform="`translate(0, ${setSvgTransform})`">
            <path d="M522.8,76c12.5-16.5,18.7-30.4,18.7-41.5c0-9.3-3.2-16.9-9.6-22.7c-6.4-5.8-14.7-8.7-25.1-8.7
              c-3,0-5.8,0.3-8.5,0.8v5.5c2.6-0.6,5.4-0.9,8.5-0.9c8.7,0,15.7,2.4,21,7.2c5.3,4.8,8,11.2,8,19.1c0,9.5-6.1,22.4-18.2,38.8
              l-19.3,25.3v9.1C513.4,88.4,521.5,77.8,522.8,76z"/>
            <path d="M546.7,135.3v-1.5c0-1.3-0.6-1.9-1.9-1.9h-46.3v5.3h46.3C546.1,137.2,546.7,136.6,546.7,135.3z"/>
          </g>
          <g :class="showSlogan ? 'fadein setanimate' : 'fadein'" :transform="`translate(0, ${setSvgTransform2})`">
            <path d="M595.6,4.3h2.5c1.3,0,1.9,0.6,1.9,1.9v128.9c0,1.3-0.6,1.9-1.9,1.9h-1.9c-1.3,0-1.9-0.6-1.9-1.9V12.7
              c0-0.3-0.1-0.4-0.3-0.6c-0.2-0.1-0.4-0.1-0.7,0l-20.8,10.6c-0.5,0.3-0.9,0.4-1.1,0.4c-0.9,0-1.4-0.4-1.5-1.3l-0.4-1.3
              c-0.1-0.1-0.2-0.4-0.2-0.8c0-0.8,0.4-1.3,1.1-1.7l22.7-13.1C593.8,4.5,594.6,4.3,595.6,4.3z"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loadingOption: {
      type: Object,
      required: true
    },
    speed: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      showSlogan: false,
      hideSlogan: false,
      boxWidth: 0,
      boxHeight: 0,
      setRectIn: null,
      setRectOut: null,
      setSvgSize: {},
      setSvgTransform: -50,
      setSvgTransform2: 50
    }
  },
  methods: {
    setTransform(type) {
      const self = this;
      function animated(duration) {
        let oldTimestamp = null;
        function step(newTimestamp) {
          if(oldTimestamp !== null) {
            // 分類
            if(type === 'plus') {
              self.setSvgTransform += 50 * (newTimestamp - oldTimestamp) / duration;
              if(self.setSvgTransform >= 0) {
                self.setSvgTransform = 0;
                return;
              }
            } else {
              self.setSvgTransform2 -= 50 * (newTimestamp - oldTimestamp) / duration;
              if(self.setSvgTransform2 <= 0) {
                self.setSvgTransform2 = 0;
                return;
              }
            }
          }
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      }
      animated(1000);
    },
    animated(duration) {
      const self = this;
      const initialDelay = 500; // 首頁初次載入延遲
      const timeout = 1400; // setTimeout秒數配合css的animation時間
      let oldTimestamp = null;
      function step(newTimestamp) {
        if(oldTimestamp !== null) {
          if(self.showSlogan) {
            // 閉合
            // return
            self.setRectOut -= self.boxHeight * (newTimestamp - oldTimestamp) / duration;
            self.hideSlogan = true;
            if(self.setRectOut <= 0) {
              self.setRectOut = 0;
              self.closeLoading();
              return;
            }
          } else {
            // 翻開
            self.setRectIn -= self.boxHeight * (newTimestamp - oldTimestamp) / duration;
            if(self.setRectIn <= 0) {
              self.setRectIn = 0;
              self.showSlogan = true;
              self.changeBox(self.loadingOption.contentNum);
              self.setTransform('plus');
              self.setTransform('minus');
              setTimeout(() => {
                self.animated(self.speed);
              }, timeout);
              return;
            }
          }
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      }
      // 首頁初次載入
      if(self.loadingOption.initial) {
        setTimeout(() => {
          self.showSlogan = true;
          self.setTransform('plus');
          self.setTransform('minus');
        }, initialDelay);
        self.changeBox(self.loadingOption.contentNum);
      }
      setTimeout(() => {
        window.requestAnimationFrame(step);
      }, self.loadingOption.initial ? timeout + initialDelay : 0);
      
    },
    changeBox(num) {
      this.$emit('loadingOpen', num);
    },
    closeLoading() {
      this.$emit('loadingDone');
    }
  },
  mounted() {
    const height = this.$refs.loading.clientHeight;
    this.boxWidth = this.$refs.loading.clientWidth;
    this.boxHeight = height;
    this.setRectIn = this.loadingOption.initial ? 0 : height;
    this.setRectOut = height;
    this.animated(this.speed);
    if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
      this.setSvgSize = {
        width: this.$refs.svgWrapper.clientWidth,
        height: this.$refs.svgWrapper.clientWidth * 0.7
      }
    }
  }
}
</script>

<style>
#loading {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(to top, #1e3c72 0%, #131f40 75%, #131f40 100%);
  z-index: 999;
}
#loading .businesstoday {
  position: absolute;
  top: 0;
  left: 0;
  margin: 1em;
}
.loadingbox {
  position: absolute;
  width: 35%;
  max-width: 640px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loadingbox img {
  position: absolute;
  width: 80%;
  top: -10%;
  left: 0;
  margin-left: 14%;
}
.loadingbox svg {
  display: block;
  width: 100%;
}
.loadingbox::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 55%;
  width: 55%;
  height: 10%;
  transform: translate(-50%, -50%);
  background-image: radial-gradient(closest-side, rgba(255, 224, 171, 0.2) 0, rgba(255, 224, 171, 0.08) 35%, transparent 100%);
  opacity: 0;
  transition: 1s;
}
.loadingbox.shadowIn::after {
  opacity: 1;
}
#loading svg path {
  fill:#ffe0ab;
}
.fadein {
  opacity: 0;
}
.fadein.setanimate {
  animation: fadeIn 1s forwards;
}
.fade-out-top {
  animation: fadeOutTop 1s forwards;
}

@-webkit-keyframes fadeOutTop {
  from {
    opacity: 1;
    transform: translate(0, 0);
  }
  to {
    opacity: 0;
    transform: translate(0, -10em);
  }
}

@keyframes fadeOutTop {
  from {
    opacity: 1;
    transform: translate(0, 0);
  }
  to {
    opacity: 0;
    transform: translate(0, -10em);
  }
}

@media screen and (max-width: 768px) {
  .loadingbox {
    width: 50%;
  }
}

@media screen and (max-width: 480px) {
  .loadingbox {
    width: 80%;
  }
}

</style>
